<template>
  <div class="login" >
    <div class="login-box" v-if="loginShow">
      <div class="title">用户登录</div>
      <div class="con">
        <!--prefix-icon="el-icon-user"-->
        <el-input class="user" placeholder="请输入账号" v-model="userName" />
        <!--prefix-icon="el-icon-user"-->
        <el-input class="psw" type="password" placeholder="请输入密码" v-model="password" />
        <el-button @click="login">登录</el-button>
      </div>
    </div>

    <div class="update-box" v-if="updateShow">
      <div class="title">修改密码</div>
      90天未更新密码，需更新
      <div class="con">
        <!--prefix-icon="el-icon-user"-->
        <el-input class="user" placeholder="请输入账号" v-model="userName" />
        <!--prefix-icon="el-icon-user"-->
        <el-input class="psw" type="password" placeholder="请输入旧密码" v-model="passwordOld" />
        <el-input class="psw" type="password" placeholder="请输入新密码" v-model="passwordNew" />
        <el-input class="psw" type="password" placeholder="请确认新密码" v-model="passwordCom" />
        <el-button @click="update">确认</el-button>
      </div>
    </div>
  </div>

  <!--<div class="login" v-if="updateShow">-->
    <!---->
  <!--</div>-->
</template>

<script>
import { Message, Loading } from 'element-ui';
import { Base64 } from 'js-base64';
import jsCookie from 'js-cookie';
import qs from 'qs';
export default {
  name: 'Login',
  data() {
    return {
      userName: '',
      password: '',
      loginShow:true,
      updateShow:false,
      passwordOld: '',
      passwordNew: '',
      passwordCom: '',
      // userName: 'gsl_large_screen',
      // password: 'Abcde01!'
    };
  },
  methods: {
    login() {
      if (this.userName && this.password && this.validatePassword (this.password)) {
        this.$api.login
                .getUserReload({
                  'userName':this.userName
                })
                .then((res) => {
                  if (res.data) {
                    this.updateShow = true;
                    this.loginShow = false;
                    // return false;
                  } else {
                    this.$auth.login(this.userName, Base64.encode(this.password));
                  }
                });
      }
      // else {
      //   this.$message.warning('请输入账号密码！');
      // }
    },
    update(){
      if (this.userName
              && this.validatePassword (this.passwordOld)
              && this.validatePassword (this.passwordNew)) {
        this.$api.login.update(
                        qs.stringify({
                          username: this.userName,
                          passwordOld: this.passwordOld,
                          passwordNew: this.passwordNew,
                        })
                )
                .then((res) => {
                  console.log('res',res)
                  if (res.data) {
                    this.updateShow = false;
                    this.loginShow = true;
                    this.loading = false;
                    this.$message.info('更新成功!');
                    return
                  } else {
                    this.$message.warning('更新失败!');
                    return
                  }
                })
                .catch((err) => {
                  this.$message.warning('更新失败!');
                });
      }
    },
    validatePassword (value){
      if (!value) {
        this.$message.warning("请输入密码");
        return false
      }

      // 最小长度验证
      if (value.length < 8) {
        this.$message.warning("密码长度至少为8位");
        return false
      }

      // 复杂度验证
      let hasNumber = false;
      let hasLetter = false;
      let hasSpecialChar = false;

      for (let char of value) {
        if (char >= '0' && char <= '9') {
          hasNumber = true;
        } else if ((char >= 'a' && char <= 'z') || (char >= 'A' && char <= 'Z')) {
          hasLetter = true;
        } else if ('!@#$%^&*()_+-=[]{}|;:,.<>?'.includes(char)) {
          hasSpecialChar = true;
        }
      }

      if (!hasNumber) {
        this.$message.warning("密码必须包含数字");
        return false
      }

      if (!hasLetter) {
        this.$message.warning("密码必须包含字母");
        return false
      }

      if (!hasSpecialChar) {
        this.$message.warning("密码必须包含特殊字符 (!@#$%^&*等)\"");
        return false
      }
      return true
    }

},
  mounted() {
    let loading = Loading.service({});
    setTimeout(() => {
      loading.close();
    }, 200);
    if (jsCookie.get(Base64.encode('token')) && !sessionStorage.getItem('expiredTime')) {
      let expiredTime = new Date().getTime() + 1000 * 60 * 60 * 12;
      sessionStorage.setItem('expiredTime', expiredTime);
      location.reload();
    }
  },
};
</script>

<style lang="less" scoped>
.login {
  width: 100%;
  height: 1565px;
  /*height: 100vh;*/
  .flex-center();
  justify-content: center;
  background: url('~img/login/bg.png') no-repeat;
  background-size: 145%;
  background-position: top right;

  .login-box {
    width: 740px;
    height: 796px;
    background: #fff;
    box-shadow: 0 4px 40px 0 rgba(201, 208, 228, 0.58) inset, 0 8px 8px 0 rgba(62, 101, 178, 0.19);
    border-radius: 48px;
    border: 4px solid rgba(201, 208, 228, 0.48);
    /*border-image: linear-gradient(180deg, rgba(255, 255, 255, 1), rgba(255, 255, 255, 1)) 4 4;*/
    /*clip-path: inset(0 round 48px);*/
    backdrop-filter: blur(6px);
    position: fixed;
    left: 612px;

    .title {
      width: 100%;
      height: 119px;
      border-bottom: 2px solid #e9e9e9;
      .flex-center();
      justify-content: center;
      font-size: 34px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      color: #456bd1;
      line-height: 31px;
    }

    .con {
      margin: 120px 70px;
      .flex-center();
      flex-direction: column;
      justify-content: center;
      padding-left: 20px;

      .el-input {
        margin-bottom: 80px;
        position: relative;

        &::before {
          content: '';
          display: block;
          width: 42px;
          height: 42px;
          position: absolute;
          left: 20px;
          top: 16px;
          background-size: 100% 100% !important;
        }

        &.user::before {
          background: url('~img/login/user.png') no-repeat;
        }

        &.psw::before {
          background: url('~img/login/psw.png') no-repeat;
        }
      }

      /deep/.el-input__inner {
        width: 574px;
        height: 66px;
        background: #f6f8fb;
        border-radius: 4px;
        border: 1px solid #e9edf2;
        font-size: 26px;
        padding-left: 70px;
      }

      .el-button {
        width: 574px;
        height: 66px;
        background: #456bd1;
        box-shadow: 1px 1px 2px 0px #9cb6fa, inset 2px 2px 6px 0px #6d8ce0, inset -1px -1px 6px 0px #355cc4;
        border: 1px solid #f2f6ff;
        color: #fff;
        font-size: 30px;
        font-weight: bold;
        margin-top: 20px;
      }
    }
  }

  .update-box {
    width: 740px;
    height: 796px;
    background: #fff;
    box-shadow: 0 4px 40px 0 rgba(201, 208, 228, 0.58) inset, 0 8px 8px 0 rgba(62, 101, 178, 0.19);
    border-radius: 48px;
    border: 4px solid rgba(201, 208, 228, 0.48);
    /*border-image: linear-gradient(180deg, rgba(255, 255, 255, 1), rgba(255, 255, 255, 1)) 4 4;*/
    /*clip-path: inset(0 round 48px);*/
    backdrop-filter: blur(6px);
    position: fixed;
    left: 612px;

    .title {
      width: 100%;
      height: 119px;
      border-bottom: 2px solid #e9e9e9;
      .flex-center();
      justify-content: center;
      font-size: 34px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      color: #456bd1;
      line-height: 31px;
    }

    .con {
      margin: 10px 70px;
      .flex-center();
      flex-direction: column;
      justify-content: center;
      padding-left: 20px;

      .el-input {
        margin-bottom: 25px;
        position: relative;

        &::before {
          content: '';
          display: block;
          width: 42px;
          height: 42px;
          position: absolute;
          left: 20px;
          top: 16px;
          background-size: 100% 100% !important;
        }

        &.user::before {
          background: url('~img/login/user.png') no-repeat;
        }

        &.psw::before {
          background: url('~img/login/psw.png') no-repeat;
        }
      }

      /deep/.el-input__inner {
        width: 574px;
        height: 66px;
        background: #f6f8fb;
        border-radius: 4px;
        border: 1px solid #e9edf2;
        font-size: 26px;
        padding-left: 70px;
      }

      .el-button {
        width: 574px;
        height: 66px;
        background: #456bd1;
        box-shadow: 1px 1px 2px 0px #9cb6fa, inset 2px 2px 6px 0px #6d8ce0, inset -1px -1px 6px 0px #355cc4;
        border: 1px solid #f2f6ff;
        color: #fff;
        font-size: 30px;
        font-weight: bold;
        margin-top: 20px;
      }
    }
  }
}
</style>
